<template>
  <div>
    <b-modal
      centered
      id="modal-note-patcher"
      title="Редагувати нотатку"
      @ok="handleOk"
    >
      <b-form-select
        class="mt-1 form-control"
        :options="options"
        v-model="note.category"
      ></b-form-select>
      <b-form-textarea class="mt-3" v-model="note.text"></b-form-textarea>
    </b-modal>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </div>
</template>

<script>
const axios = require("axios");
import Alert from "@/components/Toasts/Alert";

export default {
  name: "NotePatcher",
  components: {
    Alert,
  },
  props: {
    note: {},
  },
  data: function () {
    return {
      activErr: false,
      class: "",
      AlertText: "",
      options: [
        { value: "success", text: "Звичайна" },
        { value: "danger", text: "Важлива" },
      ],
    };
  },
  methods: {
    async handleOk() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      };
      let payload = {
        text: this.note.text,
        category: this.note.category,
      };
      await axios
        .put(
          `${process.env.VUE_APP_API}/notes/patch/${this.note.id}`,
          payload,
          config,
        )
        .then((response) => {
          this.note = response.data;
          this.showModalCreate("Нотатка успішно створена!", "green");
          this.$nextTick(() => {
            this.$bvModal.hide("modal-note-patcher");
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else {
            this.showModalCreate("Щось пішло не так", "red");
            this.$nextTick(() => {
              this.$bvModal.hide("modal-note-patcher");
            });
          }
        });
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color;
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
  },
};
</script>

<style scoped></style>
